require('../../bootstrap');
require('babel-polyfill');

window.Vue = require('vue');

const App = require('./components/App.vue');

const store = require('./store/').default;

const app = new Vue({
    el: '#app',
    store,
    render: h => h(App),
});


// WEBPACK FOOTER //
// ./resources/assets/js/front/cart/cart.js